const colorMap = {
'L2-3 CUX2 ACVR1C INHBA': '#838383',
'L2-3 CUX2 ARHGAP18': '#A0522D',
'L2-3 CUX2 PLCXD3': '#CD853F',
'L3-5 RORB GABRG1 PLCH1': '#D2691E',
'L3-5 RORB GABRG1 PTPRO': '#FF8C00',
'L3-5 RORB PCBP3 ARHGAP15': '#FFD700',
'L3-5 RORB TNNT2 PRRX1': '#F0E68C',
'L5-6 FEZF2 NXPH2 GPC5': '#808000',
'L5-6 FEZF2 NXPH2 GRIK1': '#9ACD32',
'L5-6 FEZF2 NXPH2 SORCS3': '#7CFC00',
'L6 FEZF2 DCBLD1 MITF': '#4CAF50',
'L6 FEZF2 EYA1': '#2E8B57',
'L6 FEZF2 HCRTR2 THSD7B': '#00FF7F',
'L6 FEZF2 NPFFR2 KCNK2': '#69c63f',
'L6 FEZF2 SYT6 ERBB4': '#228B22',
'L6 FEZF2 SYT6 PTPRT': '#006400',
'L6 FEZF2 SYT6 SULF1': '#00FF00',
'L6 OPRK1 SMYD1 ADAMTS17': '#7FFF00',
'L6 OPRK1 SMYD1 SNTB1': '#8FBC8F',
'Macro F13A1 COLEC12': '#90EE90',
'Micro P2RY12 CCL3': '#38A169',
'Micro P2RY12 GLDN': '#27AE60',
'Myeloid LSP1 LYZ': '#10B981',
'Oligo MOG CDH7': '#047857',
'Oligo MOG FRY': '#065F46',
'Oligo MOG GSN': '#064E3B',
'RB HBA1 HBB': '#14532D',
'SMC ACTA2 CNN1': '#166534',
'SMC ACTA2 CRISPLD2': '#154360',
'SMC ACTA2 CYP1B1': '#0F172A',
'T SKAP1 CD247': '#1E40AF',
'VLMC COL1A2 SLC13A3': '#3B82F6',
'VLMC COL1A2 VLMCA8': '#2563EB',
'VLMC SLC47A1 SLC4A4': '#1D4ED8',
'Endo CLDN5 DKK2': '#3B5BDB',
'Endo CLDN5 IL1R1': '#4338CA',
'InN ADARB2 CADPS2': '#5335A3',
'InN ADARB2 CALCR': '#6366F1',
'InN ADARB2 COL5A2': '#7C3AED',
'InN ADARB2 PALMD': '#8B5CF6',
'InN ADARB2 RGS10': '#A855F7',
'InN LAMP5 ADAMTS20': '#b47a1d',
'InN LAMP5 MEIS2': '#D87CFE',
'InN PVALB PRKCH': '#A78BFA',
'InN PVALB SNTB1': '#C084FC',
'InN PVALB SYT2': '#D977F3',
'InN SST ADAMTSL1': '#082567',
'InN SST ADRA1D': '#06ceff',
'InN SST GABRQ': '#003153',
'InN SST HGF': '#f5f5dc',
'InN SST KLHL14': '#191970',
'InN SST NPY': '#06ffa3',
'InN VIP ADAM12': '#000080',
'InN VIP FREM2': '#fffe06',
'InN VIP LHFP': '#06c4ff',
'InN VIP MEGF11': '#F472B6',
'InN VIP PENK': '#0695ff',
'COP GPR17 SOX4': '#EC4899',
'Astro AQP4 SLC1A2': '#E91E63',  
'Astro GFAP AQP1': '#AF7AC5',    

'InN ADARB2 FAM19A1': '#7497C3',  
'InN LAMP5 BMP7': '#6289B9',      
'InN PVALB HPSE': '#527AA8',     
'InN PVALB PDE3A': '#89ABD0',     
'InN SST FREM1': '#7B9DC2',       
'InN VIP CLSTN2': '#6A8BB0',      

'L2-3 CUX2 ACVR1C THSD7A': '#4D8B6C',  
'L2-3 CUX2 NTNG1 PALMD': '#228B22',    
'L2-3 CUX2 RORB CLMN': '#006400',      

'L3-5 RORB GABRG1 KCNH7': '#E6b261',
'L3-5 RORB MKX DCC': '#F39C12',        
'L3-5 RORB MKX GRIN3A': '#D4AC0D',     

'L5-6 FEZF2 NXPH2 CDH8': '#F4D03F',    
'L6 FEZF2 NPFFR2 TPD52L1': '#D35400',  
'L6 OPRK1 SMYD1 KCND2': '#E74C3C',     
'L6 OPRK1 THEMIS RGS6': '#A93226',     

'Micro P2RY12 APBB1IP': '#7D3C98',    
'OPC PDGFRA PCDH15': '#873600',        

'Oligo MOG OPALIN': '#DEB887',
'PC P2RY14 GRM8': '#B67F96',
'L2-4 CUX2 RORB CLMN': '#3CB371',

'Astro GFAP FABP7': '#FFA07A',  

'InN LAMP5 LHX6 TAC1': '#4682B4', 
'InN LAMP5 RELN': '#5F9EA0',      
'InN PVALB ANOS1': '#4169E1',     
'InN PVALB PIEZO2': '#1E90FF',    
'InN SST HTR2C': '#6495ED',       
'InN SST HS3ST5': '#87CEEB',      
'InN SST PLPP4': '#00BFFF',       
'InN SST STK32A': '#B0C4DE',      
'InN SST THSD7B': '#ADD8E6',      
'InN SST TRPC7': '#87CEFA',       
'InN VIP EGF': '#40E0D0',         
'InN VIP EXPH5': '#48D1CC',       
'InN VIP HS3ST3B1': '#00CED1',    
'InN VIP SCML4': '#20B2AA',      
'L3-5 RORB MKX GALR1': '#F4A460',   
'L3-5 RORB PCBP3 IL1RAPL2': '#DEB887', 
'L3-5 RORB PCBP3 LINGO2': '#D2B48C',   
'L3-5 RORB TNNT2 TSHZ2': '#DAA520',    
'L5 FEZF2 BCL11B POU3F1': '#CD853F',   
'L6 FEZF2 SYT6 CDH9': '#D2691E',        
'L2-3 CUX2 NTNG1 PLCH1': '#3CB371',   
'L2-3 CUX2 NTNG1 COL5A2': '#2E8B57',   

'L3-5 RORB MKX SCN5A': '#F0C477',

'InN ADARB2 SFRP2': '#4F94CD',
  '001 CLA-EPd-CTX Car3 Glut': '#76C9A2',
    '002 IT EP-CLA Glut': '#A0522D',
    '003 L5/6 IT TPE-ENT Glut': '#4AC29A',
    '004 L6 IT CTX Glut': '#43A86B',
    '005 L5 IT CTX Glut': '#5AC37E',
    '006 L4/5 IT CTX Glut': '#69D2A7',
    '007 L2/3 IT CTX Glut': '#A0DB8E',
    '008 L2/3 IT ENT Glut': '#7BC67E',
    '009 L2/3 IT PIR-ENTl Glut': '#53B68D',
    '010 IT AON-TT-DP Glut': '#6FD6A0',
    '011 L2 IT ENT-po Glut': '#8FE6A2',
    '012 MEA Slc17a7 Glut': '#5DC49D',
    '014 LA-BLA-BMA-PA Glut': '#A3D9A5',
    '016 CA1-ProS Glut': '#F08060',
    '017 CA3 Glut': '#EA7D54',
    '018 L2 IT PPP-APr Glut': '#70B97B',
    '019 L2/3 IT PPP Glut': '#FF82AB',
    '020 L2/3 IT RSP Glut': '#62D19B',
    '021 L4 RSP-ACA Glut': '#A4D6B7',
    '022 L5 ET CTX Glut': '#4B0082',
    '023 SUB-ProS Glut': '#8CCB9F',
    '024 L5 PPP Glut': '#FF69B4',
    '025 CA2-FC-IG Glut': '#8B3A3A',
    '026 NLOT Rho Glut': '#7A3E3E',
    '028 L6b/CT ENT Glut': '#B2E8C3',
    '029 L6b CTX Glut': '#84EAC2',
    '030 L6 CT CTX Glut': '#B7D9B0',
    '031 CT SUB Glut': '#52A884',
    '032 L5 NP CTX Glut': '#82B47D',
    '033 NP SUB Glut': '#D56542',
    '034 NP PPP Glut': '#FF1493',
    '035 OB Eomes Ms4a15 Glut': '#D57B62',
    '036 HPF CR Glut': '#AEE2AB',
    '037 DG Glut': '#46B3C7',
    '038 DG-PIR Ex IMN': '#48C9C3',
    '039 OB Meis2 Thsd7b Gaba': '#385A72',
    '041 OB-in Frmd7 Gaba': '#386582',
    '042 OB-out Frmd7 Gaba': '#387092',
    '043 OB-mi Frmd7 Gaba': '#387BA2',
    '044 OB Dopa-Gaba': '#388672',
    '045 OB-STR-CTX Inh IMN': '#4BA094',

    '046 Vip Gaba': '#6AC5F7',
    '047 Sncg Gaba': '#38A7A2',
    '048 RHP-COA Ndnf Gaba': '#38B2B2',
    '049 Lamp5 Gaba': '#3B8FC7',
    '050 Lamp5 Lhx6 Gaba': '#485A72',
    '051 Pvalb chandelier Gaba': '#486582',
    '052 Pvalb Gaba': '#4D7FC2',
    '053 Sst Gaba': '#87B8E6',
    '054 STR Prox1 Lhx6 Gaba': '#5CB7E4',
    '055 STR Lhx8 Gaba': '#489182',
    '056 Sst Chodl Gaba': '#8EC3E9',
    '057 NDB-SI-MA-STRv Lhx8 Gaba': '#3E8CCF',
    '058 PAL-STR Gaba-Chol': '#6DB6E7',
    '059 GPe-SI Sox6 Cyp26b1 Gaba': '#48B2B2',
    '060 OT D3 Folh1 Gaba': '#9FD3F6',
    '061 STR D1 Gaba': '#4682BF',
    '062 STR D2 Gaba': '#8CB7DD',
    '063 STR D1 Sema5a Gaba': '#5D96C7',
    '064 STR-PAL Chst9 Gaba': '#7DB5DA',
    '065 IA Mgp Gaba': '#588672',
    '066 NDB-SI-ant Prdm12 Gaba': '#589182',
    '067 LSX Sall3 Pax6 Gaba': '#589C92',
    '068 LSX Otx2 Gaba': '#58A7A2',
    '069 LSX Nkx2-1 Gaba': '#68AAD8',
    '070 LSX Prdm12 Slit2 Gaba': '#58BDC2',
    '071 LSX Prdm12 Zeb2 Gaba': '#3897C4',
    '072 LSX Sall3 Lmo1 Gaba': '#4FC0E8',
    '073 MEA-BST Sox6 Gaba': '#687092',
    '074 MEA-BST Lhx6 Sp9 Gaba': '#687BA2',
    '075 MEA-BST Lhx6 Nr2e1 Gaba': '#688672',
    '076 MEA-BST Lhx6 Nfib Gaba': '#689182',
    '077 CEA-BST Gal Avp Gaba': '#689C92',
    '078 SI-MA-ACB Ebf1 Bnc2 Gaba': '#68A7A2',
    '079 CEA-BST Six3 Cyp26b1 Gaba': '#6DABD7',
    '080 CEA-AAA-BST Six3 Sp9 Gaba': '#68BDC2',
    '081 ACB-BST-FS D1 Gaba': '#6CAFE4',
    '082 CEA-BST Ebf1 Pdyn Gaba': '#786582',
    '083 CEA-BST Rai14 Pdyn Crh Gaba': '#787092',
    '084 BST-SI-AAA Six3 Slc22a3 Gaba': '#787BA2',
    '085 SI-MPO-LPO Lhx8 Gaba': '#6F9FC6',
    '086 MPO-ADP Lhx8 Gaba': '#7CF1F7',
    '087 MPN-MPO-LPO Lhx6 Zfhx3 Gaba': '#789C92',
    '088 BST Tac2 Gaba': '#78A7A2',
    '089 PVR Six3 Sox3 Gaba': '#78B2B2',
    '090 BST-MPN Six3 Nrgn Gaba': '#78BDC2',
    '092 TMv-PMv Tbx3 Hist-Gaba': '#5E7FC7',
    '093 RT-ZI Gnb3 Gaba': '#3A8CC6',
    '094 SCH Six6 Cdc14a Gaba': '#3A9FC6',
    '097 PVHd-SBPV Six3 Prox1 Gaba': '#B47EB8',
    '098 AHN-SBPV-PVHd Pdrm12 Gaba': '#B48FB8',    
    '100 AHN Onecut3 Gaba': '#B4A0B8',  
    '101 ZI Pax6 Gaba': '#7AC3EA',
    '102 DMH-LHA Gsx1 Gaba': '#B4C2A6',            
    '103 PVHd-DMH Lhx6 Gaba': '#B4D3B6', 
    '104 TU-ARH Otp Six6 Gaba': '#B3D8F7',
    '105 TMd-DMH Foxd2 Gaba': '#B4F5D6',
    '106 PVpo-VMPO-MPN Hmx2 Gaba': '#8FC5E6',
    '107 DMH Hmx2 Gaba': '#947EB8',              
    '108 ARH-PVp Tbx3 Gaba': '#886582',
    '109 LGv-ZI Otx2 Gaba': '#887092',
    '111 TRS-BAC Sln Glut': '#6C9CD2',

    '113 MEA-COA-BMA Ccdc42 Glut': '#A2D3E3',
    '114 COAa-PAA-MEA Barhl2 Glut': '#D67052',
    '115 MS-SF Bsx Glut': '#D67B62',
    '116 AVPV-MEPO-SFO Tbr1 Glut': '#D68672',
    '117 LHA Barhl2 Glut': '#D69182',
    '118 ADP-MPO Trp73 Glut': '#D69C92',    
    '119 SI-MA-LPO-LHA Skor1 Glut': '#E57373',
    '120 MEA Otp Foxp2 Glut': '#D6B2B2',
    '121 MEA-BST Otp Zic2 Glut': '#D6BDC2',
    '123 DMH Nkx2-4 Glut': '#C65A32',
    '124 MPN-MPO-PVpo Hmx2 Glut': '#F44336',
    '126 ARH-PVp Tbx3 Glut': '#C67052',
    '128 VMH Fezf1 Glut': '#C67B62',
    '129 VMH Nr5a1 Glut': '#E53935',
    '130 LHA Pmch Glut': '#F06292',
    '131 LHA-AHN-PVH Otp Trh Glut': '#C69182',
    '132 AHN-RCH-LHA Otp Fezf1 Glut': '#C69C92',
    '133 PVH-SO-PVa Otp Glut': '#FF8A80',
    '134 PH-ant-LHA Otp Bsx Glut': '#C6B2B2',
    '135 STN-PSTN Pitx2 Glut': '#F48FB1',
    '136 PMv-TMv Pitx2 Glut': '#B95A32',
    '137 PH-an Pitx2 Glut': '#B96542',
    '138 PH Pitx2 Glut': '#B97052',
    '139 PH-LHA Foxb1 Glut': '#B97B62',
    '140 PMd-LHA Foxb1 Glut': '#B98672',
    '141 PH-SUM Foxa1 Glut': '#B99182',
    '143 MM-ant Foxb1 Glut': '#EC407A',
    '144 MM Foxb1 Glut': '#FF1744',
    '145 MH Tac2 Glut': '#D32F2F',
    '149 PVT-PT Ntrk1 Glut': '#B9B2B2',
    '150 CM-IAD-CL-PCN Sema5b Glut': '#D81B60',
    '151 TH Prkcd Grin2c Glut': '#FF7043',  
    '152 RE-Xi Nox4 Glut': '#D75A32',
    '153 MG-POL-SGN Nts Glut': '#D76542',
    '154 PF Fzd5 Glut': '#D77052',
    '155 PRC-PAG Pax6 Glut': '#D77B62',
    '158 MRN-PAG Nkx6-1 Glut': '#D78672',
    '160 PAG-SC Neurod2 Meis2 Glut': '#D79182',
    '161 PAG Pou4f3 Glut': '#D79C92',
    '162 CUN Evx2 Lhx2 Glut': '#D7A7A2',
    '163 APN C1ql2 Glut': '#D7B2B2',
    '164 APN C1ql4 Glut': '#D7BDC2',
    '165 PAG-MRN Pou3f1 Glut': '#C75A32',
    '166 MRN Pou3f1 C1ql4 Glut': '#C76542',
    '167 PRC-PAG Tcf7l2 Irx2 Glut': '#C77052',
    '168 SPA-SPFm-SPFp-POL-PIL-PoT Sp9 Glut': '#C77B62',
    '169 PAG-SC Pou4f1 Zic1 Glut': '#C78672',
    '170 PAG-MRN Tfap2b Glut': '#C79182',
    '171 PAG Pou4f1 Bnc2 Glut': '#C79C92',
    '172 PAG Pou4f1 Ebf2 Glut': '#C7A7A2',
    '173 PAG Pou4f2 Glut': '#C7B2B2',
    '174 PAG Pou4f2 Mesi2 Glut': '#C7BDC2',
    '175 SC Bnc2 Glut': '#BA5A32',
    '176 SCig Foxb1 Glut': '#BA6542',
    '177 SCig-an-PPT Foxb1 Glut': '#BA7052',
    '178 SCig Foxb1 Otx2 Glut': '#BA7B62',
    '181 IC Tfap2d Maf Glut': '#BA8672',
    '182 CUN-PPN Evx2 Meis2 Glut': '#BA9182',
    '185 SCig Tfap2b Chrnb3 Glut': '#BA9C92',
    '186 SCop Pou4f2 Neurod2 Glut': '#BAA7A2',
    '187 SCsg Pde5a Glut': '#BAB2B2',
    '188 SCop Sln Glut': '#BABDC2',
    '190 ND-INC Foxd2 Glut': '#D85A32',
    '192 PPN-CUN-PCG Otp En1 Gaba': '#885A92',
    '193 MRN-PPN-CUN Pax8 Gaba': '#886592',
    '195 SNr-VTA Pax5 Npas1 Gaba': '#887B92',
    '196 PAG-PPN Pax5 Sox21 Gaba': '#888682',
    '198 IC Six3 En2 Gaba': '#889192',
    '199 PAG-MRN-RN Foxa2 Gaba': '#889C92',
    '200 PAG-ND-PCG Onecut1 Gaba': '#88A7A2',
    '201 PAG-RN Nkx2-2 Otx1 Gaba': '#88B2B2',
    '203 LGv-SPFp-SPFm Nkx2-2 Tcf7l2 Gaba': '#985A72',
    '204 SC Otx2 Gcnt4 Gaba': '#986582',
    '205 SC-PAG Lef1 Emx2 Gaba': '#987092',
    '206 SCm-PAG Cdh23 Gaba': '#987BA2',
    '207 SCs Dmbx1 Gaba': '#988672',
    '208 SC Lef1 Otx2 Gaba': '#989182',
    '209 SCs Pax7 Nfia Gaba': '#989C92',
    '210 PRT Mecom Gaba': '#98A7A2',
    '211 SC Tnnt1 Gli3 Gaba': '#98B2B2',
    '212 SCs Lef1 Gli3 Gaba': '#98BDC2',

    '215 SNc-VTA-RAmb Foxa1 Dopa': '#FFA7C6',
    '216 MB-MY Tph2 Glut-Sero': '#F8BBD0',
    '213 SCsg Gabrr2 Gaba': '#E68AB8',
    '202 PRT Tcf7l2 Gaba': '#D6368e',
    '183 PBG Mtnr1a Glut-Chol': '#E3799E',
    '220 PB Pax5 Glut': '#D85A42',
    '221 LDT-PCG Vsx2 Lhx4 Glut': '#D86552',
    '222 PB Evx2 Glut': '#D87062',
    '223 B-PB Nr4a2 Glut': '#D87B72',
    '224 PCG-PRNr Vsx2 Nkx6-1 Glut': '#D88682',
    '228 PSV Pvalb Lhx2 Glut': '#D89192',
    '230 PRNr Otp Nfib Glut': '#D89C92',
    '231 IPN-LDT Vsx2 Nkx6-1 Glut': '#D8A7A2',
    '233 NLL-SOC Spp1 Glut': '#D8B2B2',
    '234 MEV Ppp1r1c Glut': '#D8BDC2',
    '235 PG-TRN-LRN Fat2 Glut': '#FBC6B5',
    '237 PRP-NI-PRNc-GRN Otp Glut': '#C86542',
    '238 NTS Phox2b Glut': '#C87052',
    '243 PGRN-PARN-MDRN Hoxb5 Glut': '#FFDAB9',
    '246 CU-ECU-SPVI Foxb1 Glut': '#C88672',
    '248 MV-SPIV Zic4 Neurod2 Glut': '#C89182',
    '251 NTS Dbh Glut': '#C89C92',
    '255 SPVO Mafa Meis2 Glut': '#C8A7A2',
    '261 HB Calcb Chol': '#91BDC2',
    '262 Pineal Crx Glut': '#BB5A32',
    '263 CS-RPO Meis2 Gaba': '#A86582',
    '264 PRNc Otp Gly-Gaba': '#F6CDA6',
    '265 PB Sst Gly-Gaba': '#918672',
    '270 LDT-DTN Gata3 Nfix Gaba': '#A87092',
    '271 NI-RPO Gata3 Nr4a2 Gaba': '#A87BA2',
    '272 LDT-PCG-CS Gata3 Lhx1 Gaba': '#A88672',
    '273 PDTg-PCG Pax6 Gaba': '#A89182',
    '274 PDTg Otp Shroom3 Gaba': '#A89C92',
    '276 LDT-PCG St18 Gaba': '#A8A7A2',
    '277 DTN-LDT-IPN Otp Pax3 Gaba': '#A8B2B2',
    '278 NLL Gata3 Gly-Gaba': '#919182',
    '283 PRP Otp Gly-Gaba': '#919C92',
    '285 MY Lhx1 Gly-Gaba': '#91A7A2',
    '294 MV Pax6 Gly-Gaba': '#91B2B2',
    '300 PARN-MDRNd-NTS Gbx2 Gly-Gaba': '#7FA8AD',

    '304 NTS-PARN Neurod2 Gly-Gaba': '#928672',
    '305 SPVI-SPVC Sall3 Nfib Gly-Gaba': '#929182',
    '308 DCO Il22 Gly-Gaba': '#929C92',
    '310 CBX Golgi Gly-Gaba': '#92A7A2',
    '311 CBX MLI Megf11 Gaba': '#B85A92',
    '312 CBX MLI Cdh22 Gaba': '#B86592',
    '314 CB Granule Glut': '#E3F2FD',      
    '318 Astro-NT NN': '#FFF59D',          
    '319 Astro-TE NN': '#FFD54F',
    '323 Ependymal NN': '#B2EBF2',         
    '325 CHOR NN': '#D7CCC8',              
    '326 OPC NN': '#F8E9A1',               
    '327 Oligo NN': '#f2ecde',          
    '329 ABC NN': '#B0BEC5',               
    '330 VLMC NN': '#DADADA',
    '331 Peri NN': '#A1887F',
    '332 SMC NN': '#D7CCC8',
    '333 Endo NN': '#BCAAA4',
    '334 Microglia NN': '#90A4AE',
    '335 BAM NN': '#B0BEC5',
    '338 Lymphoid NN': '#B2BABB',
    '320 Astro-OLF NN': '#9999FF',       
    '321 Astroependymal NN': '#FFFF99',  
    '322 Tanycyte NN': '#FF99FF',
    '324 Hypendymal NN': '#FFB366', 
    '336 Monocytes NN': '#9966FF',
    '337 DC NN': '#FFB399'
}
export default colorMap;